export default __webpack_public_path__ + "_/images/promo_action/instructions/image1-b8d90320dea949528fafd15afcadf967d02e214f6f2b6166ec165cd7fb30daf2.png";